import { Directive } from '@angular/core';

@Directive({
    selector: '[ce-checkbox-helper-text]',
    host: {
        class: 'u-color-text-secondary',
    },
    standalone: true,
})
export class CeCheckboxHelperTextDirective {}

@Directive({
    selector: '[ce-error-message]',
    host: {
        class: 'u-text-body-sm u-color-text-negative',
    },
    standalone: true,
})
export class CeErrorMessageDirective {}
